import {
  GraduationCap,
  ClipboardList,
  UserCircle,
  Calendar,
  UserCheck,
  BookOpen,
  CalendarClock,
  Award,
  CreditCard,
  BadgeIndianRupee,
  Library,
  Building2,
  Briefcase,
  Bell,
  Users,
  ListChecks,
  FileText,
  BarChart3,
  FlaskConical,
  CalendarOff,
  Wallet,
  Settings,
  UserPlus,
  RefreshCw,
  ShieldCheck,
  Landmark,
  FileBarChart,
  Mail,
  FolderOpen,
  Scale,
  LayoutList,
  Ticket,
  FileQuestion,
  Monitor,
  PenLine,
  Calculator,
  ScrollText,
  RotateCcw,
  Layers,
  IndianRupee,
  Percent,
  HandCoins,
  Receipt,
  AlertCircle,
  PiggyBank,
  BookMarked,
  ArrowLeftRight,
  MonitorPlay,
  BedDouble,
  UtensilsCrossed,
  Wrench,
  Bus,
  UserRoundCheck,
  type LucideIcon,
} from "lucide-react";

export type UerpFeatureIcon =
  | "admission"
  | "course-registration"
  | "profile"
  | "timetable"
  | "attendance"
  | "assignments"
  | "exam-schedule"
  | "results"
  | "fee-payment"
  | "scholarship"
  | "library"
  | "hostel"
  | "placement"
  | "notices"
  | "class-management"
  | "attendance-marking"
  | "lesson-plan"
  | "assignment-mgmt"
  | "internal-assessment"
  | "exam-duty"
  | "mentoring"
  | "research"
  | "leave"
  | "payroll"
  | "institution-setup"
  | "admission-mgmt"
  | "student-lifecycle"
  | "hr-management"
  | "role-access"
  | "governance"
  | "analytics"
  | "notifications"
  | "documents"
  | "compliance"
  | "exam-planning"
  | "hall-ticket"
  | "question-paper"
  | "online-exam"
  | "evaluation"
  | "result-processing"
  | "certificates"
  | "revaluation"
  | "fee-structure"
  | "online-fees"
  | "concession"
  | "scholarship-disburse"
  | "receipts"
  | "defaulter"
  | "expense"
  | "financial-reports"
  | "catalogue"
  | "issue-return"
  | "e-library"
  | "hostel-allotment"
  | "mess"
  | "maintenance"
  | "transport"
  | "visitor";

export const uerpFeatureIconMap: Record<UerpFeatureIcon, LucideIcon> = {
  admission: GraduationCap,
  "course-registration": ClipboardList,
  profile: UserCircle,
  timetable: Calendar,
  attendance: UserCheck,
  assignments: BookOpen,
  "exam-schedule": CalendarClock,
  results: Award,
  "fee-payment": CreditCard,
  scholarship: BadgeIndianRupee,
  library: Library,
  hostel: Building2,
  placement: Briefcase,
  notices: Bell,
  "class-management": Users,
  "attendance-marking": ListChecks,
  "lesson-plan": FileText,
  "assignment-mgmt": PenLine,
  "internal-assessment": BarChart3,
  "exam-duty": CalendarClock,
  mentoring: UserRoundCheck,
  research: FlaskConical,
  leave: CalendarOff,
  payroll: Wallet,
  "institution-setup": Settings,
  "admission-mgmt": UserPlus,
  "student-lifecycle": RefreshCw,
  "hr-management": Users,
  "role-access": ShieldCheck,
  governance: Landmark,
  analytics: FileBarChart,
  notifications: Mail,
  documents: FolderOpen,
  compliance: Scale,
  "exam-planning": LayoutList,
  "hall-ticket": Ticket,
  "question-paper": FileQuestion,
  "online-exam": Monitor,
  evaluation: PenLine,
  "result-processing": Calculator,
  certificates: ScrollText,
  revaluation: RotateCcw,
  "fee-structure": Layers,
  "online-fees": IndianRupee,
  concession: Percent,
  "scholarship-disburse": HandCoins,
  receipts: Receipt,
  defaulter: AlertCircle,
  expense: PiggyBank,
  "financial-reports": FileBarChart,
  catalogue: BookMarked,
  "issue-return": ArrowLeftRight,
  "e-library": MonitorPlay,
  "hostel-allotment": BedDouble,
  mess: UtensilsCrossed,
  maintenance: Wrench,
  transport: Bus,
  visitor: UserRoundCheck,
};
